const settings = (
  state = {
    unavailable_days: 7,
    flexibility: 4,
  },
  action
) => {
  switch (action.type) {
    case "SET_SETTINGS":
      return action.settings;
    default:
      return state;
  }
};

export default settings;
